import React from 'react';
import PropTypes from 'prop-types';

import ConfirmModal from 'components/ConfirmModal';
import Content from 'components/ConfirmModal/Content';
import Title from 'components/ConfirmModal/Title';
import Footer from 'components/ConfirmModal/Footer';

import PrimaryButton from 'styled/Buttons/PrimaryButton';
import SecondaryButton from 'styled/Buttons/SecondaryButton';
import SimpleList from 'styled/SimpleList';

import ItemCheckbox from './ItemCheckbox';
import CustomLabel from './CustomLabel';
import RadioButton from './RadioButton';

export const REJECT_REASONS = {
  popular_event_on_video:
    'Материал отклонён. Спасибо за попытку, но, увы, с этого события уже прислали много видео! Буду ждать от тебя новых материалов!',
  accepted_some_other_videos:
    'Материал отклонён. Некоторые из твоих видео я одобрил и вскоре ты получишь гонорар. Спасибо! Жду от тебя новых материалов!',
  not_exclusive_video:
    'Материал отклонён. Заработать можно на своих, эксклюзивных видео! Спасибо за попытку! Буду ждать от тебя новых материалов!',
  cant_publish:
    'Материал отклонён. Благодарим, но данное событие не может быть опубликовано нами.',
  need_video:
    'Материал отклонён. Очень нужно видео, а не фото с места события! Попробуй ещё раз! Спасибо!',
  not_important_video:
    'Материал отклонён. Спасибо за попытку, но лучше присылать видео текущих, значимых событий! Жду от тебя новых материалов!',
};

export class MaterialCardModal extends React.PureComponent {
  state = {
    message: Object.keys(REJECT_REASONS)[0],
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown = (e) => {
    const KEY_ESC = 27;

    switch (e.keyCode) {
      case KEY_ESC:
        this.props.onClose();
        break;
      default:
        break;
    }
  };

  handleMessageChange = ({ target }) => {
    const message = REJECT_REASONS[target.value];

    if (!target.value || !message) return;

    this.setState({ message: target.value });
  }

  handleSubmit = () => {
    this.props.onClick(this.state.message);
  }

  render() {
    return (
      <React.Fragment>
        <ConfirmModal
          onKeyDown={this.handleKeyDown}
          isOpen={this.props.isOpen}
          onClose={this.props.onClose}
          styles={{ width: '464px' }}
        >
          <Content style={{ paddingBottom: '0' }}>
            <Title style={{ marginBottom: '24px' }}>Причина отклонения</Title>

            <SimpleList style={{ marginBottom: '24px' }}>
              {Object.keys(REJECT_REASONS).map(reason => (
                <li key={reason}>
                  <CustomLabel>
                    <RadioButton
                      type="radio"
                      name="rejectExplain"
                      value={reason}
                      checked={reason === this.state.message}
                      onChange={this.handleMessageChange}
                      autoFocus={reason === this.state.message || !this.state.message}
                    />

                    <ItemCheckbox />

                    {REJECT_REASONS[reason]}
                  </CustomLabel>
                </li>
              ))}
            </SimpleList>

            <Footer>
              <PrimaryButton
                style={{ marginRight: '16px' }}
                type="button"
                onClick={this.handleSubmit}
                disabled={!this.state.message}
              >
                Выбрать
              </PrimaryButton>

              <SecondaryButton type="button" onClick={this.props.onClose}>Отмена</SecondaryButton>
            </Footer>
          </Content>
        </ConfirmModal>
      </React.Fragment>
    );
  }
}

MaterialCardModal.propTypes = {
  onClose: PropTypes.func,
  onClick: PropTypes.func,
  isOpen: PropTypes.bool,
};

MaterialCardModal.defaultProps = {
  onClose: () => {},
  onClick: () => {},
  isOpen: false,
};

export default MaterialCardModal;
